<div class="other-information">
  <form class="form">
    <div class="construction">
      <app-construction></app-construction>
    </div>
    <div class="other-information">
      <app-other-infos></app-other-infos>
    </div>
    <div class="documentation">
      <app-documentation></app-documentation>
    </div>
    <div class="btn-actions">
      <lib-button-tertiary >Cancelar</lib-button-tertiary>
      <lib-button-primary >Salvar</lib-button-primary>
    </div>
  </form>
</div>